module.exports = __webpack_public_path__ + "img/geo-zones-3.150d3e47.gif";